/**
 * Slugify a string for use in anchor links and IDs
 * Supports ASCII, Japanese (Hiragana, Katakana, Kanji), and provides fallback for empty results
 */
export const slugify = (text: string): string => {
  const slug = text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD') // Unicode正規化
    // biome-ignore lint/suspicious/noMisleadingCharacterClass: Standard regex for removing diacritics
    .replace(/[\u0300-\u036f]/g, '') // アクセント記号を削除
    .replace(/\s+/g, '-') // スペースをハイフンに
    // 英数字、日本語（ひらがな、カタカナ、漢字）、ハイフンを許可
    .replace(/[^\w\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF-]+/g, '')
    .replace(/--+/g, '-') // 連続するハイフンを1つに
    .replace(/^-+/, '') // 先頭のハイフンを削除
    .replace(/-+$/, ''); // 末尾のハイフンを削除

  // 空の場合はタイムスタンプベースのフォールバック
  return slug || `heading-${Date.now()}`;
};
